export default axios => ({
  /**
   * Возвращает список всех жалоб
   *
   * @param pageSize
   * @param currentPage
   * @param sort
   * @param order
   * @returns {*}
   */
  list ({ pageSize = 10, currentPage = 1, sort = 'id', order = 'DESC' } = {}) {
    const body = {
      pageSize: pageSize,
      pageIndex: currentPage,
      sort: sort,
      order: order
    }

    return axios.get('/web/report/list', {
      params: body
    })
  },
  /**
   * Возвращает список жалоб - Профиль,Площадка,Отзыв
   *
   * @param id
   * @returns {*}
   */
  report (id) {
    return axios.get(`/web/report/get/${id}`)
  }
})
